module.exports = __webpack_public_path__ + "img/lllustration.3f90206.svg";